module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-32x9-cfb5c0bbac906aeba9aecd8332f6253c.jpg";